import { i18nLike } from "#web/services/i18nLike";
import { Icon, Text, Tooltip } from "@shopify/polaris";
import { AlertTriangleIcon } from "@shopify/polaris-icons";

import { LeakedCode } from "../_models/leakedCode";
import * as s from "./styles.css";
import { en } from "./translations";

export const HighRiskTooltip = ({ leakedCode }: { leakedCode: LeakedCode }) => {
  const t = i18nLike(en);

  return (
    <Tooltip content={t("highRisk.tooltip")}>
      <span className={s.HighRiskTooltipIconWrapper}>
        <Icon source={AlertTriangleIcon} tone="critical" />
        <Text as="span" fontWeight="bold" variant="bodyMd">
          {leakedCode.code}
        </Text>
      </span>
    </Tooltip>
  );
};
